import select from './select';

const on = (elements, event, callback) => {
    select(elements).forEach((item) => item.addEventListener(event, callback));
};

export default on;
